var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreenhouse = function SvgGreenhouse(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.647,
    d: "M12.741 25.92v-6.656c-5.9.827-9.856-3.127-11.414-12.965 5.183-.73 9.498.18 12.89 2.811 3.61-4.533 8.89-6.655 16.458-5.47.152 9.314-3.019 15.39-11.565 16.217v5.993z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.647,
    d: "M1.327 6.3c7.899-1.53 16.625 4.022 16.735 7.632M4.222 29.185c4.108-4.85 20.733-3.968 23.31.124"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreenhouse);
export default ForwardRef;